export default "__VITE_ASSET__CmuA_jLL__"